import React from 'react';
import { useLocation } from "react-router-dom";

import TeamPage from '../../Team/TeamPage'
import '.././manageEvents.css';


const Team = (props) => {
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const profileId = pathParts[2];

    return (
        <div className='manage_events_container p-4'>
            <p className='heading'>Team</p>
            <TeamPage {...props} profileId={profileId} module="event-profile" />
        </div>
    )
}

export default Team